<template>
  <wa-page
    ref="pageRef"
    view-slug="home"
  >
    <wa-page-header
      slot="header"
      key="header"
    />

    <main
      slot="content"
      role="main"
      style="
        --button-border-radius: var(--card-border-radius);
        --card-margin-bottom: 2em;
        --grid-gutter-x-width: 1rem;
        --h4-font-size: 1.125em;
        --h4-margin-bottom: 0.625em;
        --headings-font-weight: 700;
      "
    >
      <hero />

      <div
        ref="StickyElementParent"
        class="container"
      >
        <home-nav :is-sticky-element-stuck="isStickyElementStuck" />

        <span
          ref="StickyElementSentinel"
          aria-hidden="true"
          class="sticky-element-sentinel"
        ></span>

        <fa7-pro />

        <start-free v-if="!isSignedIn" />

        <pro-plus />

        <tech />

        <styling />

        <plan-compare />
      </div>

      <modal-utility-announcement
        :is-showing="isShowingUtilityAnnouncementModal"
        @close-modal="hideUtilityAnnouncementModal()"
      />

      <open-source />
      <logos ref="logos" />
    </main>

    <wa-page-footer slot="footer" />
  </wa-page>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Hero from './sections/Hero'
  import HomeNav from './sections/HomeNav'
  import Fa7Pro from './sections/Fa7Pro'
  import StartFree from './sections/StartFree'
  import ProPlus from './sections/ProPlus'
  import Tech from './sections/Tech'
  import Styling from './sections/Styling'
  import PlanCompare from './sections/PlanCompare'
  import OpenSource from './sections/OpenSource'
  import Logos from './sections/Logos'
  import { EventTrackingMixin, StickyElementMixin } from 'app/mixins'
  import ModalUtilityAnnouncement from 'app/components-wa/modals/ModalUtilityAnnouncement'

  export default {
    name: 'Home',

    components: {
      Hero,
      HomeNav,
      Fa7Pro,
      StartFree,
      ProPlus,
      Tech,
      Styling,
      PlanCompare,
      OpenSource,
      Logos,
      ModalUtilityAnnouncement
    },

    mixins: [EventTrackingMixin, StickyElementMixin],

    data() {
      return {
        isShowingUtilityAnnouncementModal: true
      }
    },

    computed: {
      ...mapGetters('subscriptions', ['currentSubscription']),

      isSignedIn() {
        return this.$route.meta.isSignedIn
      },

      nextUrl() {
        const { origin } = window.location

        return `${origin}${this.$route.query.next}`
      }
    },

    mounted() {
      this.$forceUpdate()
      this.$posthog.capture('home_view', this.determinationsEventProps)

      this.isShowingUtilityAnnouncementModal = !document.cookie.includes('showUtilityAnnouncementModal')
    },

    methods: {
      hideUtilityAnnouncementModal() {
        this.isShowingUtilityAnnouncementModal = false
        document.cookie = 'showUtilityAnnouncementModal = false'
      }
    }
  }
</script>
